import React from 'react';
import './main.less';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actions, selectors } from './';

import { withViewsState } from '../shared/render-views-state';
import withIntl from '../shared/intl-hoc';
import Animate from '../shared/animation';

import Table from '../shared/new-table/main';
import { createRenderSortingTH } from '../shared/new-table/renderers';
import Filters from '../shared/filters/main';
import Calendar from '../shared/calendar/main';
import SwitchControlMulti from '../shared/switch-control/multi/main';
import Pagination from '../shared/new-pagination/main';

function Main({ intl, ...props }) {
	return (
		<Animate>
			<div className="container__content">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">
							{intl('ranks-and-points')}
						</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="clearfix">
						<Filters
							intl={intl}
							{...props.filters}
							filters={props.filters} // for crutch support
						/>
					</div>
					<div className="ui-control-bar">
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<SwitchControlMulti
									intl={intl}
									filters={props.rankSwitch.filters}
									choose={props.rankSwitch.switchControlMultiChooseFilter}
								/>
							</div>
						</div>
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<Calendar
									intl={intl}
									dateRange={props.calendar.dateRange}
									isOpen={props.calendar.isOpen}
									ranges={props.calendar.ranges}
									startDate={props.calendar.startDate}
									endDate={props.calendar.endDate}
									onInit={props.calendar.calendarInit}
									onToggle={props.calendar.calendarToggle}
									onChange={props.calendar.calendarChange}
									onApply={props.calendar.calendarApply}
								/>
							</div>
						</div>
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position ranks-points-btns">
								<button
									className="ui-btn ui-btn-primary apply"
									onClick={props.apply}
								>
									{intl('Apply')}
								</button>
								<button
									className="ui-btn ui-btn-secondary clear"
									onClick={props.clear}
								/>
							</div>
						</div>
					</div>
					<Table
						className='ranks-points-table'
						table={props.tableData.table}
						rows={props.tableData.rows}
						renderTH={createRenderSortingTH({
							sortedBy: props.tableData.sortedBy,
							sort: props.tableData.sort
						})}
					/>
					<Pagination {...props.pagination} />
				</div>
			</div>
		</Animate>
	);
}

function mapStateToProps(state) {
	return {
		data: selectors.getData(state),
		can: selectors.getCan(state),
		progressBar: selectors.getProgressBar(state),
		error: selectors.getError(state),
		// -----------------------------------------
		table: selectors.getTable(state),
		pagination: selectors.getPagination(state),
		filters: selectors.getFilters(state),
		calendar: selectors.getCalendar(state),
		rankSwitch: selectors.getRankSwitch(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		table: bindActionCreators(actions.table, dispatch),
		pagination: bindActionCreators(actions.pagination, dispatch),
		filters: bindActionCreators(actions.filters, dispatch),
		calendar: bindActionCreators(actions.calendar, dispatch),
		rankSwitch: bindActionCreators(actions.rankSwitch, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		tableData: {
			...stateProps.table,
			...dispatchProps.table
		},
		pagination: {
			...stateProps.pagination,
			...dispatchProps.pagination
		},
		filters: {
			...stateProps.filters,
			...dispatchProps.filters
		},
		calendar: {
			...stateProps.calendar,
			...dispatchProps.calendar
		},
		rankSwitch: {
			...stateProps.rankSwitch,
			...dispatchProps.rankSwitch
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
	withViewsState(withIntl(Main), 'view')
);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/ranks-points-report/main.js